import locale from "@/helpers/locale";
import moment from "moment";
import { MessageBox } from "element-ui";
export const addWelfareCouponItem = () => {
  return {
    couponId: "",
    couponCount: 0
  };
};

export const addRankRuleItem = () => {
  return {
    months: null,
    years: null,
    type: "",
    total: null,
  };
};

export const addRankSetting = type => {
  return {
    rankRule: type === "down" ? [] : [ addRankRuleItem() ],
    rankRuleMethod: "one",
    message: "",
    messageTitle: ""
  };
};

export const addRankListItem = sort => {
  return  {
    name: "",
    sort,
    upgradeWelfare: {
      couponList: [ addWelfareCouponItem() ],
      memberShipPoint: null,
    },
    schedulePoint: 0,
    ticketPoint: 0,
    costPoint: 0,
    concessionPoint: 0,
    commercialPoint: 0,
    upgradeRankSetting: addRankSetting(),
    downgradeRankSetting: addRankSetting("down"),
    explanation: "",
    GENERAL_TICKET: true,
    MEMBER_TICKET: true,
    CONCESSION: true,
    COMMERCIAL: true,
  };
};


export const getGroupTab = () => {
  return [
    {
      text: locale("membership.memberList.dialog.history.ticket"),
      type: "ticket"
    },
    {
      text: locale("membership.memberList.dialog.history.shop"),
      type: "shop"
    },
    {
      text: locale("trans.other.coupon"),
      type: "coupon",
    },
    {
      text: locale("membership.memberList.dialog.history.ticket-history"),
      type: "couponUse"
    },
    {
      text: locale("membership.memberList.dialog.history.point"),
      type: "point"
    },
    // {
    //   text: locale("cashierReport.dialog.ticket"),
    //   type: "ticket"
    // },
    // {
    //   text: locale("membership.memberList.dialog.history.sales-history"),
    //   type: "salesHistory"
    // },
    // {
    //   text: locale("membership.memberList.dialog.history.merchandise-sales-history"),
    //   type: "merchandiseSalesHistory"
    // },
    {
      text: locale("membership.memberList.dialog.history.rank-history"),
      type: "rank"
    },
    {
      text: locale("membership.memberList.dialog.history.change-history"),
      type: "memberShipChange"
    }
  ];
};

export const getExpiredOption = () => [
  {
    name: locale("couponLib.deadline"),
    value: "DEADLINE",
  },
  {
    name: locale("couponLib.period"),
    value: "PERIOD",
  },
  {
    name: locale("couponLib.none"),
    value: "NONE"
  }
];

export const getExpiredTimeOption = () => [
  {
    label: locale("calendar.day"),
    value: "DAYS",
  },
  {
    label: locale("calendar.month"),
    value: "MONTHLY",
  },
  {
    label: locale("calendar.year"),
    value: "YEAR",
  }
];

const dateFormatter = (row, column, cellValue) => {
  return !cellValue ? "無制限" : moment(cellValue).format("YYYY/MM/DD");
}
const timeFormatter = (row, column, cellValue) => {
  return !cellValue ? "無制限" : moment(cellValue).format("YYYY/MM/DD HH:mm");
};
const expiredTimeFormatter = (row, column, cellValue) => {
  return !cellValue ? "" : moment(cellValue).format("YYYY/MM/DD HH:mm");
};

export const getMemberCouponStatus = () => [
  {
    label: "期限切れ",
    value: "expired"
  },
  {
    label: "未使用",
    value: "normal"
  },
  {
    label: "使用済み",
    value: "used"
  }
];

const memberCouponStatusFormatter = (row, column, cellValue) => {
  return (getMemberCouponStatus().find(item => item.value === cellValue) || {}).label;
};

export const getUsePlace = () => [
  {
    label: "劇場窓口",
    value: "window"
  },
  {
    label: "CMS",
    value: "cms"
  },
  {
    label: "ネット",
    value: "online"
  }
];
export const getHistoryTableObj = (
  cinemaList,
  couponList,
  memberShipList,
  rankList,
  filmList,
  salesStatusObj,
  taxRatesMap) => {
  const shopThead = [
    {
      prop: "transactionCreateTime",
      label: locale("membership.memberList.dialog.history.shop.createTransactionTime"),
      width: 180,
      sort: "custom",
      formatter: (row, column, cellValue) => moment(cellValue).format("YYYY-MM-DD HH:mm")
    },
    {
      prop: "productName",
      label: locale("membership.memberList.dialog.history.shop.productName"),
      width: 180,
    },
    {
      prop: "unitPrice",
      label: locale("membership.memberList.dialog.history.shop.unitPrice"),
      width: 80,
      formatter: (row, column, cellValue) => "¥" + cellValue.toLocaleString()
    },
    {
      prop: "taxRate",
      label: locale("membership.memberList.dialog.history.shop.taxRate"),
      width: 30,
      formatter: (row, column, cellValue) => taxRatesMap[cellValue]
    },
    {
      prop: "qty",
      label: locale("membership.memberList.dialog.history.shop.qty"),
      width: 30,
    },
    {
      prop: "total",
      label: locale("membership.memberList.dialog.history.shop.total"),
      width: 80,
      formatter: (row, column, cellValue) => "¥" + cellValue.toLocaleString()
    }
  ];
  return {
    coupon: {
      thead: [
        {
          label: locale("membership.memberList.dialog.history.couponID"),
          prop: "couponId",
          width: 120,
          sort: "custom",
          columnKey: "couponId"
        },
        {
          label: locale("membership.memberList.dialog.history.couponName"),
          prop: "name",
          width: 100,
          sort: "custom",
          columnKey: "couponName"
        },
        {
          label: locale("memberShip.log.count"),
          prop: "count",
          width: 100,
          formatter: row => {
            return !row.countLimit ? locale("couponLib.none") : row.count;
          }
        },
        {
          label: locale("memberShip.log.expiredTime"),
          prop: "expireTime",
          formatter: dateFormatter,
          sort: "custom",
          columnKey: "expireTime"
        },
        {
          label: locale("membership.memberList.dialog.history.getDate"),
          prop: "createTime",
          width: 100,
          formatter: timeFormatter,
          sort: "custom",
          columnKey: "createTime"
        },
        {
          label: locale("global.state"),
          prop: "memberCouponStatus",
          filters: getMemberCouponStatus().map(item => ({
            text: item.label,
            value: item.value
          })),
          filteredValue: [],
          columnKey: "memberCouponStatus",
          formatter: memberCouponStatusFormatter,
        },
        // {
        //   label: locale("membership.memberList.dialog.history.useTheater"),
        //   prop: "cinemaId",
        //   filters: cinemaList.map(item => ({
        //     text: item.name,
        //     value: item.id
        //   })),
        //   columnKey: "cinemaId",
        //   formatter: (row, column, cellValue) => {
        //     return (cinemaList.find(item => item.id === cellValue) || {}).name;
        //   }
        // },
      ],
      tableData: []
    },
    couponUse: {
      thead: [
        {
          label: locale("membership.memberList.dialog.history.table.useDate"),
          prop: "createTime",
          width: 120,
          sort: "custom",
          formatter: timeFormatter
        },
        {
          label: locale("membership.memberList.dialog.history.couponID"),
          prop: "couponId",
          width: 120,
          sort: "custom",
        },
        {
          label: locale("membership.memberList.dialog.history.couponTypeId"),
          prop: "memberCouponId",
          width: 120,
          sort: "custom",
        },
        {
          label: locale("membership.memberList.dialog.history.couponName"),
          prop: "couponId",
          width: 120,
          sort: "custom",
          formatter: (row, column, cellValue) => {
            return (couponList.find(item => item.id === cellValue) || {}).name;
          }
        },
        {
          label: locale("memberShip.log.useCount"),
          prop: "useCount",
          width: 120,
        },
        {
          label: locale("membership.memberList.status"),
          prop: "useType",
          width: 120,
          filters: [
            {
              text: "獲得",
              value: "get"
            },
            {
              text: "使用",
              value: "use"
            },
          ],
          filteredValue: [],
          columnKey: "useType",
          formatter: (row, column, cellValue) => {
            return ([
              {
                text: "獲得",
                value: "get"
              },
              {
                text: "使用",
                value: "use"
              },
            ].find(item => item.value === cellValue) || {}).text;
          },
        },
        {
          label: locale("membership.memberList.dialog.history.table.usePlace"),
          prop: "placeType",
          width: 120,
          filters: getUsePlace().map(item => ({
            text: item.label,
            value: item.value
          })),
          filteredValue: [],
          columnKey: "placeType",
          formatter: (row, column, cellValue) => {
            return (getUsePlace().find(item => item.value === cellValue) || {}).label;
          },
        },
        {
          label: locale("membership.memberList.dialog.history.useTheater"),
          prop: "cinemaId",
          formatter: (row, column, cellValue) => {
            return (cinemaList.find(item => item.id === cellValue) || {}).name;
          },
          filters: cinemaList.map(item => ({
            text: item.name,
            value: item.id
          })),
          columnKey: "cinemaId",
        },
        {
          label: locale("cashierReport.dialog.formField.comment"),
          prop: "remark",
          width: 120,
        },
      ],
      tableData: []
    },
    ticket: {
      thead: [
        {
          prop: "searchId",
          label: locale("trans.koisk.transid"),
          width: 180
        },
        {
          prop: "transactionCreateTime",
          label: locale("global.date"),
          width: 180,
          sort: "custom",
          formatter: (row, column, cellValue) => moment(cellValue).format("YYYY-MM-DD HH:mm")
        },
        {
          prop: "filmName",
          label: locale("global.titleOfWork"),
          width: 200,
          formatter: (row, column, cellValue) => filmList.find(item => item.id === cellValue) ? filmList.find(item => item.id === cellValue).name : cellValue
        },
        {
          prop: "scheduleStartTime",
          label: locale("operation.NAT.screenDate"),
          width: 120,
          formatter: (row, column, cellValue) => moment(cellValue).format("YYYY-MM-DD")
        },
        {
          prop: "scheduleStartTime",
          label: locale("operation.NAT.showTime"),
          width: 80,
          formatter: (row, column, cellValue) => moment(cellValue).format("HH:mm")
        },

        {
          prop: "houseName",
          label: locale("global.screen"),
          width: 120
        },
        {
          prop: "seatName",
          label: locale("theatre.seatType"),
          width: 70
        },
        {
          prop: "ticketTypeName",
          label: locale("trans.report.ticketTypeName"),
          width: 120
        },
        {
          prop: "couponTypeName",
          label: locale("global.coupon"),
          width: 200
        },
        {
          prop: "total",
          label: locale("global.amount"),
          width: 120,
          formatter: (row, column, cellValue) => "¥" + cellValue.toLocaleString(),
        },
        {
          prop: "paymentName",
          label: locale("trans.report.paymentMethod"),
          width: 120
        },
        {
          prop: "operator",
          label: locale("inventoryLog.changePeople"),
          width: 160,
          formatter: (row, column, cellValue) => row.platform + "/" + cellValue
        },
        {
          prop: "itemStatus",
          label: locale("global.status"),
          width: 110,
          formatter: (row, column, cellValue) => salesStatusObj[cellValue]
        }
      ],
      tableData: []
    },
    shop: {
      thead: shopThead,
      tableData: [],
    },
    point: {
      thead: [
        {
          label: locale("global.date"),
          prop: "createTime",
          width: 120,
          sort: "custom",
          formatter: timeFormatter
        },
        {
          label: locale("membership.detail.form.points"),
          prop: "point",
          width: 120,
          sort: "custom",
        },
        {
          label: locale("membership.detail.form.offSetPoints"),
          prop: "currentPoint",
          width: 120,
          sort: "custom",
        },
        {
          label: locale("cashierReport.dialog.formField.comment"),
          prop: "remark",
          width: 120,
        },
      ],
      tableData: []
    },
    rank: {
      thead: [
        {
          label: locale("memberShip.occurDate"),
          prop: "createTime",
          width: 120,
          sort: "custom",
          formatter: timeFormatter,
        },
        {
          label: locale("membership.coupon.rank"),
          prop: "membershipRankName",
          width: 120,
          filters: rankList.map(item => ({
            text: item.name,
            value: item.uuid
          })),
          columnKey: "membershipRankId"

        },
        {
          label: locale("global.remarks"),
          prop: "remark",
          width: 120,
        },
      ],
      tableData: []
    },
    memberShipChange: {
      thead: [
        {
          label: locale("memberShip.occurDate"),
          prop: "createTime",
          width: 120,
          sort: "custom",
          formatter: timeFormatter
        },
        {
          label: locale("pdfFilmFeeBalance.th.cinema"),
          prop: "cinemaId",
          width: 120,
          filters: cinemaList.map(item => ({
            text: item.name,
            value: item.id
          })),
          columnKey: "cinemaId",
          formatter: (row, column, cellValue) => {
            return (cinemaList.find(item => item.id === cellValue) || {}).name;
          }
        },
        {
          label: locale("cinemaWebsite.custom.table.header.price"),
          prop: "cost",
          width: 120,
          sort: "custom",
          formatter: (row, column, cellValue) => cellValue !== null ? cellValue.toLocaleString() : ""
        },
        {
          label: locale("memberShip.log.memberShip"),
          prop: "memberShipId",
          width: 120,
          filters: memberShipList,
          filteredValue: [],
          columnKey: "memberShipId",
          formatter: (row, column, cellValue) => {
            return (memberShipList.find(item => item.value === cellValue) || {}).text;
          }
        },
        {
          label: locale("memberShip.log.updateTime"),
          prop: "expiredTime",
          width: 120,
          formatter: expiredTimeFormatter
        },
        {
          label: locale("global.remarks"),
          prop: "remark",
          width: 120,
        },
      ],
      tableData: []
    }
  };
};

export const getPaymentType = () => [
  {
    label: "窓口・ネット決済",
    value: "both"
  },
  {
    label: "窓口のみ",
    value: "offline"
  },
  {
    label: "ネット決済のみ",
    value: "online"
  }
];

export const priceFormatter = number => {
  return typeof number === "number" ? number.toLocaleString() : "";
};

export const getMemberShipStatus = () => [
  {
    text: "正常",
    value: "normal"
  },
  {
    text: "新規登録停止",
    value: "noNewcomer"
  },
  {
    text: "新規登録・更新停止",
    value: "noUpdate"
  },
  {
    text: "無效",
    value: "disable"
  }
];

export const getMemberStatus = () => [
  {
    text: "常連客",
    value: "frequent",
    tips: '期間内、一定の鑑賞回数を達成',
  },
  {
    text: "一般客",
    value: "general",
  },
  {
    text: "解約済み",
    value: "leave",
  },
  {
    text: "利用停止",
    value: "disabled",
  },
  {
    text: "退会済み",
    value: "delete",
  },
  {
    text: "休眠中",
    value: "sleeping",
    tips: "期間内、売上なし",
  },
  {
    text: "有効期限切れ",
    value: "expired",
  }
];

export const getMemberGender = () => [
  {
    label: "男性",
    value: "Men"
  },
  {
    label: "女性",
    value: "Women"
  },
  {
    label: "その他",
    value: "Other"
  }
];

export const displayConfirm = (elContent, btnText, callback) => {
  const confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${elContent}</span>`;
  MessageBox.confirm(confirmHtml, "", {
    dangerouslyUseHTMLString: true,
    showClose: false,
    showCancelButton: true,
    cancelButtonClass: "egl-btn-white",
    cancelButtonText: locale("global.cancel"),
    showConfirmButton: true,
    confirmButtonClass: "egl-btn-yellow",
    confirmButtonText: btnText,
    customClass: "egl-confirm",
    closeOnClickModal: false
  }).then(() => {
    callback();
  }).catch(() => {});
};
